const { VUE_APP_API_HOST, VUE_APP_HOST, NODE_ENV = '' } = process.env;

const environment = NODE_ENV.toLowerCase();
const apiBaseUrl = VUE_APP_API_HOST;
const host = environment === 'dev' ? 'http://localhost:8080' : VUE_APP_HOST;

export { environment, apiBaseUrl, host };
